export const formatMonths = (months: number, yearsMonths: string) => {
  if (yearsMonths === 'years') {
    return `${months} Year${months === 1 ? '' : 's'}`;
  }
  return `${months} Month${months === 1 ? '' : 's'}`;
};
